module.exports = __webpack_public_path__ + "img/glorifier.dc191872.png";